export { default as DrawerHost } from './DrawerHost.vue'
export { default as TheHeader } from './header/TheHeader.vue'
export { default as ProductExplore } from './shared/ProductExplore.vue'
export { default as SplashScreen } from './shared/SplashScreen.vue'
export { default as SelectAccountPage } from './SelectAccountPage.vue'
export { default as GuideCTA } from './GuideCTA.vue'
export { default as UpdatePage } from './UpdatePage.vue'